import { combineReducers } from 'redux';

import sampleManifestSlice from './sample-manifest/state/sampleManifestSlice';
import sampleReceptionSlice from './sample-reception/state/sampleReceptionSlice';

export default combineReducers({
    sampleManifest: sampleManifestSlice,
    sampleReception: sampleReceptionSlice,
});
